var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M21.748 6.398l-1.601-1.601a.754.754 0 0 0-1.067 0l-9.596 9.596-4.565-4.597a.754.754 0 0 0-1.067 0l-1.6 1.601a.754.754 0 0 0 0 1.067l6.693 6.738a.754.754 0 0 0 1.067 0L21.748 7.465a.754.754 0 0 0 0-1.067z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }